import keycloakAxios from '@/services/axios';

export const findMyGroups = async () => {
  const response = await keycloakAxios.get('group/my');

  if (response.status >= 300) {
    throw new Error(
      `Error finding groups: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
